// Dữ liệu mẫu Services Map: sinh xác định từ hãng + cảng của domain; rotation bắt đầu bằng cảng VN, các cảng sau cùng nhóm vùng.
// Thay bằng TblService / TblServiceRoute qua DataSource khi A-07 xong.
import { PORTS, isVietnamPort } from '@hana/domain';
import { COST_CARRIERS } from './costFixtures';
import { groupOfPod } from './costRates';
import type { Service } from './types';

function rng(seed: number) {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function build(): Service[] {
  const r = rng(20261024);
  const foreign = PORTS.filter((p) => !isVietnamPort(p.code)).slice(0, 45);
  const byGroup = new Map<string, string[]>();
  for (const p of foreign) (byGroup.get(groupOfPod(p.code)) ?? byGroup.set(groupOfPod(p.code), []).get(groupOfPod(p.code))!).push(p.code);
  const groups = [...byGroup.keys()];
  const out: Service[] = [];
  COST_CARRIERS.forEach((car, ci) => {
    const n = 1 + Math.floor(r() * 3);
    for (let i = 0; i < n; i++) {
      const g = groups[Math.floor(r() * groups.length)] as string;
      const pool = [...(byGroup.get(g) ?? [])].sort(() => r() - 0.5);
      const pol = r() < 0.7 ? 'VNSGN' : 'VNHPH';
      const stops = pool.slice(0, 3 + Math.floor(r() * 5));
      const partners = COST_CARRIERS.filter((c) => c !== car && r() < 0.12).slice(0, 3);
      const freq = r() < 0.75 ? 1 : 2;
      const circuit = 14 + Math.floor(r() * 5) * 7;
      out.push({
        id: `${car[0]}${car[1]}${String.fromCharCode(65 + ((ci * 3 + i) % 26))}${i + 1}`,
        name: `${car} ${g === 'ASIA' ? 'Intra-Asia' : g === 'EUROPE' ? 'Asia–Europe' : g === 'AMERICA' ? 'Transpacific' : 'Asia–Other'} ${i + 1}`,
        carriers: [car, ...partners],
        rotation: [pol, ...stops],
        circuitDays: circuit,
        ships: Math.max(2, Math.round((circuit / 7) * freq)),
        freqPerWeek: freq,
        locked: r() < 0.25,
      });
    }
  });
  return out;
}

export const SERVICES: readonly Service[] = build();
